import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { ImportPayload } from "src/app/_models/Import/ImportModel";
import { ImportBatchDisableDeleteActionTypes } from "src/app/constants/StoreConstants";
import { ImportStatus } from "../import/import.state";

export const UploadBatchDisableDeleteCSV = createAction(
  ImportBatchDisableDeleteActionTypes.UploadBatchDisableDeleteCSV,
  props<{payload: ImportPayload}>()
);

export const UploadBatchDisableDeleteCSVSuccess = createAction(
  ImportBatchDisableDeleteActionTypes.UploadBatchDisableDeleteCSVSuccess,
  props<{result: boolean}>()
);

export const UploadBatchDisableDeleteCSVError = createAction(
  ImportBatchDisableDeleteActionTypes.UploadBatchDisableDeleteCSVError,
  props<{error: HttpErrorResponse}>()
);

export const GetBatchDisableDeleteImportStatusSuccess = createAction(
  ImportBatchDisableDeleteActionTypes.GetBatchDisableDeleteImportStatusSuccess,
  props<{result: ImportStatus}>()
);

export const GetBatchDisableDeleteImportStatusError = createAction(
  ImportBatchDisableDeleteActionTypes.GetBatchDisableDeleteImportStatusError,
  props<{error: HttpErrorResponse}>()
);

export const AuthorizeImportBatchDisableDeleteSSE = createAction(
  ImportBatchDisableDeleteActionTypes.AuthorizeImportBatchDisableDeleteSSE
);

export const AuthorizeImportBatchDisableDeleteSSESuccess = createAction(
  ImportBatchDisableDeleteActionTypes.AuthorizeImportBatchDisableDeleteSSESuccess,
  props<{result: boolean}>()
);

export const AuthorizeImportBatchDisableDeleteSSEError = createAction(
  ImportBatchDisableDeleteActionTypes.AuthorizeImportBatchDisableDeleteSSEError,
  props<{error: HttpErrorResponse}>()
);0

export const HasImportedBatchDisableDelete = createAction(
  ImportBatchDisableDeleteActionTypes.HasImportedBatchDisableDelete
);

export const HasImportedBatchDisableDeleteSuccess = createAction(
  ImportBatchDisableDeleteActionTypes.HasImportedBatchDisableDeleteSuccess,
  props<{result: number}>()
);

export const HasImportedBatchDisableDeleteError = createAction(
  ImportBatchDisableDeleteActionTypes.HasImportedBatchDisableDeleteError,
  props<{error: HttpErrorResponse}>()
);

export const DownloadBatchDisableDeleteImportErrorList = createAction(
  ImportBatchDisableDeleteActionTypes.DownloadBatchDisableDeleteImportErrorList
);

export const DownloadBatchDisableDeleteImportErrorListSuccess = createAction(
  ImportBatchDisableDeleteActionTypes.DownloadBatchDisableDeleteImportErrorListSuccess,
  props<{result: string[]}>()
);

export const DownloadBatchDisableDeleteImportErrorListError = createAction(
  ImportBatchDisableDeleteActionTypes.DownloadBatchDisableDeleteImportErrorListError,
  props<{error: HttpErrorResponse}>()
);

export const CancelBatchDisableDeleteImport = createAction(
  ImportBatchDisableDeleteActionTypes.CancelBatchDisableDeleteImport
);

export const CancelBatchDisableDeleteImportSuccess = createAction(
  ImportBatchDisableDeleteActionTypes.CancelBatchDisableDeleteImportSuccess
);

export const CancelBatchDisableDeleteImportError = createAction(
  ImportBatchDisableDeleteActionTypes.CancelBatchDisableDeleteImportError
);

export const ClearBatchDisableDeleteImportSession = createAction(
  ImportBatchDisableDeleteActionTypes.ClearBatchDisableDeleteImportSession
);

export const ClearBatchDisableDeleteImportSessionSuccess = createAction(
  ImportBatchDisableDeleteActionTypes.ClearBatchDisableDeleteImportSessionSuccess
);

export const ClearBatchDisableDeleteImportSessionResult = createAction(
  ImportBatchDisableDeleteActionTypes.ClearBatchDisableDeleteImportSessionResult,
  props<{result: boolean}>()
);

export const CloseImportBatchDisableDeleteStatus = createAction(
  ImportBatchDisableDeleteActionTypes.CloseImportBatchDisableDeleteStatus
);

export const ResetBatchDisableDeleteImportState = createAction(
  ImportBatchDisableDeleteActionTypes.ResetBatchDisableDeleteImportStatus
);